module.exports = __webpack_public_path__ + "images/85c4cbc1fdf87295b86af612a26f3214.svg";